import { supabase } from "@/integrations/supabase/client";

export class OneDriveService {
  static getOAuthUrl(): string {
    const clientId = import.meta.env.VITE_TEAMS_CLIENT_ID;
    if (!clientId) {
      throw new Error("VITE_TEAMS_CLIENT_ID is not configured");
    }

    const redirectUri = encodeURIComponent(
      `${window.location.origin}/genie-hub/connections/onedrive/callback`,
    );
    const scopes = encodeURIComponent("offline_access Files.Read User.Read");
    const state = Math.random().toString(36).substring(7);

    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=${state}`;
  }

  static async getConnectionStatus() {
    const { data, error } = await supabase.functions.invoke("cloud-storage", {
      body: {
        action: "get-status",
        data: { provider: "onedrive" },
      },
    });

    if (error) {
      throw new Error(error.message || "Failed to get connection status");
    }

    return data;
  }

  static async disconnect() {
    const { data, error } = await supabase.functions.invoke("cloud-storage", {
      body: {
        action: "revoke",
        data: { provider: "onedrive" },
      },
    });

    if (error) {
      throw new Error(error.message || "Failed to disconnect");
    }

    return data;
  }
}
